// Models Login
import { useState } from "react";
import { useNavigate } from "react-router";
import apiAuth from "../api/Auth/api-auth";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { Login } from "../models/LoginModel/login.model";
import { UseVerConvocatorias } from "./UseVerConvocatorias";
import { useEncrypt } from "./useEncrypt"

export const useLoginForm = () => {
  const navigate = useNavigate();
  const [errormsj, setErrorMsj] = useState<boolean>(false);
  const { inscribirPropuesta } = UseVerConvocatorias();
  const [mensajeError, setMensajeError] = useState("");
  const { encrypt } = useEncrypt();

interface response {
  results: any;
  message: string;
}
  const onFinish = async (
    data: Login,
    screen: string | undefined,
    id: string | undefined
  ) => {
    try {
      const res: any = await apiAuth.Login(data);
      const { results, message } = res;
      
      if (message === "Invalid password") {
        setMensajeError(
          "La contraseña actual en el sistema no coincide con la contraseña ingresada en el formulario"
        );
        return setErrorMsj(true);
      }

      if (message === "El usuario requiere cambio de contraseña") {
        navigate("/usuario/CambiarContrasena");
        setMensajeError(message);
        return setErrorMsj(true);
      }

      if (message.indexOf('Could not find user') >= 0) {
        setMensajeError("El usuario no existe, por favor regístrate.");
        return setErrorMsj(true);
      }

      if (message.indexOf('incorrectos') >= 0) {
        setMensajeError(
          message
        );
        return setErrorMsj(true);
      }
      
      if (message ==="El usuario se encuentra bloqueado. Demasiados intentos fallidos") {
        setMensajeError(
          "Escribíste tu contraseña 5 veces de manera incorrecta, vuelve a intentarlo más tarde (2 Horas a partir de tu último intento)"
        );
        return setErrorMsj(true);
      }

      if (results?.user?.inactive) {
        setMensajeError("El usuario no se encuentra activo");
        return setErrorMsj(true);
      }

      localStorage.setItem("token", results?.token);

      const encryptUserStorage = encrypt(JSON.stringify(results?.user))
      
      localStorage.setItem("user", encryptUserStorage);

      
      if (results?.user?.role_id === 2 || results?.user?.role_id === 1) {
        return navigate("/administrador");
      }

      if (results?.user?.role_id === 3 || results?.user?.role_id === null) {
        if (screen !== undefined) {
          localStorage.setItem(
            "idConvocatoriaPostulacion",
            encrypt(id.toString())
          );
          if (screen === "1") {
            if (id !== undefined) {
              let data = await apiConvocatorias.getConvocatoriaById(id);
              inscribirPropuesta(data.data, data.user);
              return navigate("/usuario/Seleccionarrol");
            }
            return navigate("/usuario/");
          }

          if (screen === "2") {
            return navigate("/usuario/beps");
          }

          if (screen === "3") {
            return navigate("/usuario/Inscribirhojadevida");
          }
        } else if (message == "El usuario requiere cambio de contraseña") {
          navigate("/usuario/CambiarContrasena");
        } else {
          return navigate("/usuario/");
        }
      }
    } catch (error) {
       if (error?.message?.indexOf('Could not find user') >= 0) {
        setMensajeError("El usuario no existe, por favor regístrate.");
        return setErrorMsj(true);
      }
      console.log(error)
      setMensajeError("Hubo un error al intentar loguearte en el sistema Intentalo más tarde");      
      return setErrorMsj(true);
    }
  };
  return { onFinish, errormsj, setErrorMsj, mensajeError, setMensajeError };
};
